import XCheckpointDataStore from '../datastores/XCheckpointDataStore';
import XCheckpointDataStoreApiRest from '../datasources/axios/api/xcheckpoint';

export default class XCheckpointDataStoreFactory {
  static create(): XCheckpointDataStore {
    return new XCheckpointDataStoreApiRest();
  }
}
